<div class="ec-container">
    <div class="ec-header pt-10">
        <app-entity-path *ngIf="ecResource"
                         [path]="ecResource.path"
                         [disabled]="true"
                         class="txt-s-14-4">
        </app-entity-path>
        <div *ngIf="!ecResource" class="txt-s-16-4">
            {{'Energy Communities'|i18n}}
        </div>
        <div *ngIf="pageTitle" class="txt-h-24-7 mt-4">
            {{pageTitle|i18n}}
        </div>
    </div>
    <div class="mt-8">
        <app-divider></app-divider>
    </div>
    <div class="ec-content">
        <router-outlet></router-outlet>
    </div>
</div>
